module.exports = __webpack_public_path__ + "static/media/gradient.5a7910fb.jpg";